<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 渠道物流
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="120px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="渠道编码" prop="channelPartnerCode">
                <el-input v-model.trim="searchform.channelPartnerCode" style="width: 100%" clearable
                  placeholder="请输入渠道编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-input v-model.trim="searchform.productCode" style="width: 100%" clearable placeholder="请输入产品编码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="productName">
                <el-input v-model.trim="searchform.productName" style="width: 100%" clearable placeholder="请输入产品名称" />
              </el-form-item>
            </el-col>

            <!-- <el-col :span="6">
              <el-form-item label="单据类型" prop="orderType">
                <el-select v-model="searchform.orderType" placeholder="请选择">
                  <el-option label="采购单" :value="1"></el-option>
                  <el-option label="销售单" :value="2"></el-option>
                  <el-option label="退货单" :value="3"></el-option>
                  <el-option label="所有" :value="null"></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->

          </el-row>
          <el-row> <el-col :span="6">
              <el-form-item label="渠道类型" prop="partnerType">
                <el-select v-model="searchform.partnerType" placeholder="请选择">
                  <el-option label="经销商" :value="1"></el-option>
                  <el-option label="终端" :value="2"></el-option>
                  <el-option label="所有" :value="null"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="创建时间" prop="datelist">
                <el-date-picker style="width: 100%" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" range-separator="-"
                  start-placeholder="开始日期" end-placeholder="结束日期" :clearable='false'></el-date-picker>
              </el-form-item>
            </el-col> -->
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br id="A1" />
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>{{ $route.meta.title }}</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width: 100%"
            id="parent">
            <af-table-column prop="channelPartnerCode" label="渠道编码" min-width="150" show-overflow-tooltip />
            <af-table-column prop="channelPartnerName" label="渠道名称" min-width="150" show-overflow-tooltip />
            <af-table-column prop="partnerType" label="渠道类型" min-width="150" show-overflow-tooltip />
            <af-table-column prop="productCode" label="产品编码" min-width="150" show-overflow-tooltip />
            <af-table-column prop="productName" label="产品名称" min-width="150" show-overflow-tooltip />
            <af-table-column prop="stockQuantity" label="库存数量" min-width="150" show-overflow-tooltip />
            <af-table-column prop="stockUnitCode" label="包装单位" min-width="160" show-overflow-tooltip />
            <af-table-column prop="createTime" label="创建时间" min-width="140" show-overflow-tooltip />
          </el-table>

          <br />
          <el-pagination background @current-change="currentchange" @size-change="limit"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { stockChannel, } from "@/api/out";
//引入导出组件模块
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.search();
    this.getmarkentinglist("", 0);
  },
  data() {
    return {
      //基础数据
      add: {
        addshow: false,
      },
      listLoading2: false,
      listLoading: false,
      tableData: [],
      productlist: [], //单据产品列表
      marketinglist: [],
      businesslist: [],
      regionlist: [],
      //分页数据
      limits: "",
      total_count: 0,
      currentPage: 1,
      imglist: [],
      searchform: {
        datelist: null,
        "page": 1,
        "limit": 10,
        "productCode": "",
        "productName": "",
        "channelPartnerCode": "",
        "orderType": null, // 单据类型：1采购单 2销售单 3退货单，传null查所有
        "partnerType": null, // 渠道类型：1经销商，2终端，传null查所有
        "createTimeStart": "", // 操作日期筛选
        "createTimeEnd": ""
      },
    };
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      this.searchform.createTimeStart = this.searchform.datelist == null ? "" : this.searchform.datelist[0];
      this.searchform.createTimeEnd = this.searchform.datelist == null ? "" : this.searchform.datelist[1];
      stockChannel(obj).then((response) => {
        this.packdate(response.data.list);
        this.tableData = response.data.list;
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
      });
    },
    // 拼装表格数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        switch (obj[i].partnerType) {
          case 1:
            obj[i].partnerType = "经销商";
            break;
          case 2:
            obj[i].partnerType = "终端门店";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.searchform.page = 1;
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.Tabledata(this.searchform);
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.Tabledata(this.searchform);
    },
    //分页每页显示条数事件
    limit(limit) {
      this.searchform.limit = limit;
      this.search();
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit",
      });
    },
  },
};
</script>
<style scoped></style>
